import styled from 'styled-components';
import { LoadingSpinner } from '../../../common/components/LoadingSpinner/LoadingSpinner';
import { ThemeColours } from '../../../common/styles/ThemeColours';
import { FONT_STACK, ZIndex } from '../../../common/styles/constants';
import { propSwitch } from '../../../common/util/propSwitch';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const AutoCompleteDropdown = styled.div`
  border: 1px solid ${ThemeColours.mono300};
  border-radius: 4px;
  width: 100%;
  z-index: ${ZIndex.OVERLAY};
`;

export const AutoCompleteResult = styled.div`
  ${FONT_STACK}
  background: ${propSwitch('aria-selected', ThemeColours.mono100, ThemeColours.white)};
  cursor: pointer;
  padding: 6px 16px;
  &:not(:first-child) {
    border-top: 1px solid ${ThemeColours.mono300};
  }
`;

export const MiniLoadingSpinner = styled(LoadingSpinner)`
  height: 64px;
`;

export const SuburbLoadingWrapper = styled.div`
  align-items: center;
  background-color: ${ThemeColours.white};
  display: flex;
  height: 32px;
  left: calc(50% - 16px);
  position: absolute;
  top: 8px;
  width: 32px;
`;
